import React from "react";
import "../styles/TermsAndConditions.scss";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <header className="terms-header">
        <img src="/images/logo.png" alt="Logo" className="logo" />
        <h2>Terms and Conditions</h2>
      </header>

      <div className="terms-content">
        <section>
          <h3>1. About these Terms</h3>
          <p>
            This website <a href="https://spraynozzle.com.au/">https://spraynozzle.com.au/</a> (Website) is operated by Spray
            Nozzle Engineering Pty. Ltd. ACN 056 441 724 (we, us, our).
            These Terms and Conditions (Terms) form a legally binding agreement
            between the user (User, you) and us. By accessing the Website and/or
            using any Resources, you accept, and agree to comply with, these
            Terms. If you disagree with these Terms, you should not access the
            Website and/or use any of the Resources.
          </p>
          <p>
            These Terms only govern your access to and use of the Website and
            Resources and not any other dealing or transaction you may have with
            us. If you enter into any transaction, or have any other dealings
            with us (whether through the Website or otherwise), then such
            transaction or dealings may be governed by the terms of a separate
            agreement between you and us.
          </p>
          <p>
            We may amend these Terms at any time by updating these Terms on our
            Website. We recommend that you check these Terms frequently as your
            continued access and use of the Website and Resources after a change
            to the Terms signifies your agreement to the modified Terms. Nothing
            in these Terms requires you to continue to access or use the Website
            or Resources if these Terms are updated.
          </p>
        </section>

        <section>
          <h3>2. Intellectual Property Rights</h3>
          <p>
            2.1 As between you and us, ownership of intellectual property rights
            in the Website and any Resources is owned by us. The Resources may
            not be passed off as your own.
          </p>
          <p>
            2.2 Except as expressly provided in these Terms, you must not,
            without our prior written permission, copy, broadcast, reproduce,
            republish, download, store (in any medium), upload to a third party,
            transmit, post, distribute, show or play in public, adapt or change
            in any way the content of, or create a derivative work from, the
            Website or the Resources.
          </p>
          <p>
            2.3 Resources contained on this Website can be downloaded only for
            informational non-commercial purposes. Otherwise, such Resources may
            not be copied, modified, distributed or otherwise exploited, without
            our prior written permission.
          </p>
        </section>

        <section>
          <h3>3. User Restrictions</h3>
          <p>3.1 You must not use this Website and Resources in any way or for any purpose that is unlawful or breaches these Terms.</p>
          <p>3.2 You must not:</p>
          <ul>
            <li>disrupt, damage, impair or interfere with the Website or any servers, software, hardware or equipment connected to it;</li>
            <li>restrict or inhibit any other user from using or enjoying the Website;</li>
            <li>attempt to bypass any firewalls associated with the Website, or distribute junk/spam emails with Resources;</li>
            <li>distribute or transmit any virus or harmful code;</li>
            <li>distribute Resources for commercial purposes;</li>
            <li>breach any applicable law regarding your use of the Website;</li>
            <li>reverse engineer, decompile or disassemble any part of the Website;</li>
            <li>modify, adapt, translate, or sell the Website or Resources;</li>
            <li>access restricted parts of the Website.</li>
          </ul>
        </section>

        <section>
          <h3>4. Monitoring access and downloads</h3>
          <p>
            For security, statistical, compliance, regulatory and other related
            purposes we may: (a) monitor the User's access to the Website and
            use of the Resources; and (b) record or otherwise capture data or
            other information relating to the User's access.
          </p>
        </section>

        <section>
          <h3>5. Variation and availability</h3>
          <p>
            The User acknowledges that we retain the sole discretion regarding
            the Resources and features, functions and other benefits that will
            be available within the Website from time to time and that:
          </p>
          <ul>
            <li>We are not obligated to maintain particular Resources.</li>
            <li>Resources may vary at any time.</li>
            <li>Not all Resources may be available at all times.</li>
            <li>Some Resources may be unavailable due to outages or beyond our control.</li>
            <li>We are not obliged to provide services such as technical support, training, or maintenance.</li>
          </ul>
        </section>

        <section>
          <h3>6. Cookies</h3>
          <p>
            During your use of the Website, we may issue to and request from your
            computer blocks of data known as “cookies”. By using this Website,
            you authorise us to issue such cookies to your device.
          </p>
        </section>

        <section>
          <h3>7. Warranties and Disclaimers</h3>
          <p>
            The Website and Resources contain general information only about our
            business. We cannot guarantee their accuracy, suitability or
            completeness. The Resources are provided “as is” without warranties
            of any kind.
          </p>
        </section>

        <section>
          <h3>8. Third Party Content</h3>
          <p>
            The Website may contain links to third-party websites and content.
            We do not accept responsibility or liability for any third-party
            content, products, or services.
          </p>
        </section>

        <section>
          <h3>9. Limitation of Liability</h3>
          <p>
            To the fullest extent allowed by law, we are not liable for loss or
            damage resulting from your use of the Website or Resources. Certain
            rights under Australian Consumer Law may still apply.
          </p>
        </section>

        <section>
          <h3>10. Overseas access</h3>
          <p>
            The Website may be accessed throughout Australia and overseas. We
            make no representations that the Website or Resources comply with
            laws outside Australia.
          </p>
        </section>

        <section>
          <h3>11. Termination</h3>
          <p>
            We may terminate these Terms and your access at any time without
            notice. You must cease using the Website immediately upon
            termination.
          </p>
        </section>

        <section>
          <h3>12. Miscellaneous</h3>
          <p>
            If any provision is invalid, the rest remain in effect. These Terms
            are governed by the laws of Victoria, Australia.
          </p>
        </section>

        <section>
          <h3>13. Definitions and interpretation</h3>
          <p>
            Definitions include: Australian Consumer Law, Data, PDH Goods or
            Services, Resources.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
